export default __webpack_public_path__ + "static/media/gallery-5.43b29235.jpg";